import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const DbDataFallback = () => (
  <>
    <div className="flex flex-col gap-2 w-full">
      <Label>Version</Label>
      <Skeleton className="h-9 w-full" />
    </div>
    <div className="flex flex-col gap-2 w-full">
      <Label>Database name</Label>
      <Skeleton className="h-9 w-full" />
    </div>
    <div className="flex flex-col gap-2 w-full">
      <Label>Database user</Label>
      <Skeleton className="h-9 w-full" />
    </div>
    <div className="flex flex-col gap-2 w-full">
      <Label>Database password</Label>
      <Skeleton className="h-9 w-full" />
    </div>
  </>
)
